<template>
    <LeftSidebar v-if="!appData.isMobile">
        <li class="nav-link" v-for="r in pc" :key="r.text">
            <router-link :to="Links.Url(r.link, r.args)" :title="r.text" :class="[isSelectUrl(Links.Url(r.link, r.args)) ? 'active' : '']" >
                <span class="menu-icon" aria-hidden="true" v-html="r.iconSvg"></span>
                <span class="link-name">{{r.text}}</span>
            </router-link>
        </li>
    </LeftSidebar>
    <LeftSidebarMobile :items="mobile" :isActive="isSelectUrl" v-else-if="!isDashboardPage" :menuCount="mobile.length"  />
</template>

<script>
import { reactive, toRefs, computed } from "vue";
    import { useRoute } from "vue-router";
    import { useStore } from "vuex";

    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { appData, C } from "@/helpers/global";
    import { Web } from "@/helpers/web";

    import LeftSidebar from "@/layouts/_partials/LeftSidebar.vue";
    import LeftSidebarMobile from "@/layouts/_partials/LeftSidebar.mobile.vue";

    import { StoreUser } from "@/store/constants";

    export default {
        props: ["type"],

        components: {
            LeftSidebar,
            LeftSidebarMobile,
        },

        mounted() {
             try {
            this.user.loadDetail(() => {});
        } catch (ex) {
            console.warn(ex);
        }
        },

        setup(props) {
            const route = useRoute();
            const store = useStore();

            const e = reactive({
                user: {
                    loadDetail(callback, reset) {
                    if (C.Int(e.user.detail?.userType) <= 0) {
                        reset = true;
                    }

                        Web.Area((wait) => {
                        store.dispatch(StoreUser.loadDetail, {
                            wait,
                            reset,
                            callback,
                        });
                        }, document.querySelector("body"));
                    },

                    detail: computed(() => {
                        return store.getters[StoreUser.getDetail];
                    }),

                    isFirstAppointment: computed(() => {
                        if (e.user.detail) {
                            return e.user.detail.isFirstAppointment;
                        }

                        return false;
                    }),
                },
            isDashboardPage: computed(() => {
                return C.Str(route.path) === Links.Url(Links.Dashboard);
            }),

                isSelectUrl(link) {
                if (C.Str(route.path) == link) {
                    return true;
                }

                return C.Str(route.path).indexOf(link.replace(/\/0/g, "")) == 0;
                },

                pc: computed(() => {
                    const icons = {
                    dashboard: `<svg viewBox="0 0 24 24" fill="none"><path d="M4 4h6v6H4V4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M14 4h6v6h-6V4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M4 14h6v6H4v-6Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M14 14h6v6h-6v-6Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>`,
                    calendar: `<svg viewBox="0 0 24 24" fill="none"><path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                    daily: `<svg viewBox="0 0 24 24" fill="none"><path d="M8 2v4M16 2v4M4 9h16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M6 4h12a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.8"/><path d="M8 13h4M8 17h8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                    books: `<svg viewBox="0 0 24 24" fill="none"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z" stroke="currentColor" stroke-width="1.8"/><path d="M9 6h7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                    chart: `<svg viewBox="0 0 24 24" fill="none"><path d="M4 19V5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4 19h16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M8 16v-5M12 16V8M16 16v-7M20 16v-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                    teacher: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" stroke-width="1.8"/><path d="M4 21a8 8 0 0 1 16 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M19 8v4M21 10h-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                    clock: `<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                    cap: `<svg viewBox="0 0 24 24" fill="none"><path d="M3 8l9-4 9 4-9 4-9-4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M7 10.5V15c0 1.7 2.2 3 5 3s5-1.3 5-3v-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M21 8v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                    resource: `<svg viewBox="0 0 24 24" fill="none"><path d="M4 7.5 12 3l8 4.5-8 4.5-8-4.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M4 12.5 12 17l8-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 17.5 12 22l8-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                    exam: `<svg viewBox="0 0 24 24" fill="none"><path d="M7 3h8l4 4v14H7V3Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M15 3v5h5M10 12h6M10 16h6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                    folder: `<svg viewBox="0 0 24 24" fill="none"><path d="M3 6.5A2.5 2.5 0 0 1 5.5 4H10l2 2h6.5A2.5 2.5 0 0 1 21 8.5v8A2.5 2.5 0 0 1 18.5 19h-13A2.5 2.5 0 0 1 3 16.5v-10Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>`,
                    bookmark: `<svg viewBox="0 0 24 24" fill="none"><path d="M6 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18l-6-4-6 4V4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>`,
                    question: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 18h.01M9.5 9a2.5 2.5 0 1 1 4.1 1.9c-.9.6-1.6 1.2-1.6 2.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/></svg>`,
                    video: `<svg viewBox="0 0 24 24" fill="none"><path d="M15 10 20 7v10l-5-3v-4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M4 6h11v12H4V6Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>`,
                    user: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" stroke-width="1.8"/><path d="M4 21a8 8 0 0 1 16 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                    settings: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" stroke="currentColor" stroke-width="1.8"/><path d="M19.4 15a1.8 1.8 0 0 0 .36 1.98l.06.06a2.1 2.1 0 0 1-2.97 2.97l-.06-.06A1.8 1.8 0 0 0 14.8 19.6a1.8 1.8 0 0 0-1.7 1.2 2.1 2.1 0 0 1-4.2 0 1.8 1.8 0 0 0-1.7-1.2 1.8 1.8 0 0 0-1.98.36l-.06.06a2.1 2.1 0 0 1-2.97-2.97l.06-.06A1.8 1.8 0 0 0 4.6 15a1.8 1.8 0 0 0-1.2-1.7 2.1 2.1 0 0 1 0-4.2 1.8 1.8 0 0 0 1.2-1.7 1.8 1.8 0 0 0-.36-1.98l-.06-.06a2.1 2.1 0 0 1 2.97-2.97l.06.06A1.8 1.8 0 0 0 9.2 4.4a1.8 1.8 0 0 0 1.7-1.2 2.1 2.1 0 0 1 4.2 0 1.8 1.8 0 0 0 1.7 1.2 1.8 1.8 0 0 0 1.98-.36l.06-.06a2.1 2.1 0 0 1 2.97 2.97l-.06.06A1.8 1.8 0 0 0 19.4 9c0 .73.44 1.39 1.2 1.7a2.1 2.1 0 0 1 0 4.2 1.8 1.8 0 0 0-1.2.1Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                    };

                    if (!e.user.isFirstAppointment) {
                                return [
                        { iconSvg: icons.dashboard, link: Links.Dashboard, text: "Panelim" },
                        { iconSvg: icons.user, link: Links.User.Profile, text: "Hesabım" },
                                ];
                        }

                    switch (props.type) {
                        case Enums.MENU_TYPE.PLAN:
                            return [
                                { iconSvg: icons.dashboard, link: Links.Dashboard, text: "Panelim" },
                                { iconSvg: icons.calendar, link: Links.Plan.WeeklyList, text: "Haftalık Planım" },
                                { iconSvg: icons.daily, link: Links.Plan.DailyList, text: "Günlük Planım" },
                                { iconSvg: icons.books, link: Links.Plan.LessonList, args: [0], text: "Derslerim" },
                                { iconSvg: icons.chart, link: Links.Plan.Analysis, text: "Analizler" },
                            ];

                        case Enums.MENU_TYPE.LIVE_EDUCATION:
                            return [
                                { iconSvg: icons.dashboard, link: Links.Dashboard, text: "Panelim" },
                                { iconSvg: icons.teacher, link: Links.LiveEducation.List, text: "Ders Al" },
                                //{ iconSvg: icons.clock, link: Links.LiveEducation.PlanList, text: "Planlı Ders" },
                                //{ iconSvg: icons.cap, link: Links.LiveEducation.HistoryList, text: "Geçmiş Dersler" },
                            ];

                        case Enums.MENU_TYPE.RESOURCE:
                            return [
                                { iconSvg: icons.dashboard, link: Links.Dashboard, text: "Panelim" },
                                { iconSvg: icons.resource, link: Links.Resource.List, args: [2], text: "Soru Bankası" },
                                { iconSvg: icons.books, link: Links.Resource.List, args: [1], text: "Konu Anlatım" },
                                { iconSvg: icons.exam, link: Links.Resource.List, args: [3], text: "Deneme" },
                            ];

                        case Enums.MENU_TYPE.DOCUMENT:
                            return [
                                { iconSvg: icons.dashboard, link: Links.Dashboard, text: "Panelim" },
                                { iconSvg: icons.bookmark, link: Links.Document.PrivateList, args: [0], text: "Özel" },
                                { iconSvg: icons.folder, link: Links.Document.PublicList, text: "Genel" },
                                { iconSvg: icons.exam, link: Links.Document.TestList, text: "Testler" },
                                { iconSvg: icons.question, link: Links.Document.QuestionList, text: "Soru Havuzu" },
                            ];

                        case Enums.MENU_TYPE.MAIN:
                        default:
                            return [
                                { iconSvg: icons.dashboard, link: Links.Dashboard, text: "Panelim" },
                                { iconSvg: icons.calendar, link: Links.Plan.WeeklyList, text: "Koçluk" },
                                { iconSvg: icons.teacher, link: Links.LiveEducation.List, text: "Özel Ders" },
                                //{ iconSvg: icons.teacher, link: Links.LiveEducation.PlanList, text: "Özel Ders" },
                                { iconSvg: icons.resource, link: Links.Document.PrivateList, args: [0], text: "Dokümanlarım" },
                                { iconSvg: icons.chart, link: Links.Plan.Analysis, text: "Analiz Merkezi" },
                                { iconSvg: icons.question, link: Links.Document.QuestionList, text: "Soru Havuzu" },
                                { iconSvg: icons.settings, link: Links.User.Profile, text: "Ayarlar" },
                            ];
                    }
                }),

                mobile: computed(() => {
                    if (!e.user.isFirstAppointment) {
                        return [
                            { icon: "icon-books-list", link: Links.Document.PrivateList, args: [0], text: "Dokümanlarım" },
                            { icon: "icon-calendar-days-regular", link: Links.Plan.WeeklyList, text: "Koçluk", isMain: true },
                            { icon: "icon-user", link: Links.User.Profile, text: "Hesabım" },
                        ];
                    }

                    switch (props.type) {
                        case Enums.MENU_TYPE.PLAN:
                            return [
                                {
                                iconSvg: `<svg viewBox="0 0 24 24" fill="none"><path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                                    link: Links.Plan.WeeklyList,
                                    text: "Haftalık Plan"
                                },
                                {
                                iconSvg: `<svg viewBox="0 0 24 24" fill="none"><path d="M8 2v4M16 2v4M4 9h16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M6 4h12a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.8"/><path d="M8 13h4M8 17h8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                                    link: Links.Plan.DailyList,
                                    text: "Günlük Plan"
                                },
                                {
                                    icon: "icon-dashboard",
                                    link: Links.Dashboard,
                                    text: "Panelim",
                                    isMain: true
                                },
                                {
                                iconSvg: `<svg viewBox="0 0 24 24" fill="none"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2Z" stroke="currentColor" stroke-width="1.8"/><path d="M9 6h7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                                    link: Links.Plan.LessonList,
                                    args: [0],
                                    text: "Derslerim"
                                },
                                {
                                iconSvg: `<svg viewBox="0 0 24 24" fill="none"><path d="M4 19V5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4 19h16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M8 16v-5M12 16V8M16 16v-7M20 16v-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                                    link: Links.Plan.Analysis,
                                    text: "Analizler"
                                },
                            ];
                            
                        case Enums.MENU_TYPE.LIVE_EDUCATION:
                            return [
                                {
                                iconSvg: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 14a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" stroke-width="1.8"/><path d="M4 21a8 8 0 0 1 16 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M19 8v4M21 10h-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                                    link: Links.LiveEducation.List,
                                    text: "Ders Al"
                                },

                                {
                                iconSvg: `<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"/><path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
                                    link: Links.LiveEducation.PlanList,
                                    text: "Planlı Ders"
                                },

                                {
                                    icon: "icon-dashboard",
                                    link: Links.Dashboard,
                                    text: "Panelim",
                                    isMain: true
                                },

                                {
                                iconSvg: `<svg viewBox="0 0 24 24" fill="none"><path d="M3 8l9-4 9 4-9 4-9-4Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M7 10.5V15c0 1.7 2.2 3 5 3s5-1.3 5-3v-4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M21 8v6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                                    link: Links.LiveEducation.HistoryList,
                                    text: "Geçmiş Dersler"
                                },

                                {
                                iconSvg: `<svg viewBox="0 0 24 24" fill="none"><path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" stroke-width="1.8"/><path d="M4 21a8 8 0 0 1 16 0" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>`,
                                    link: Links.User.Profile,
                                    text: "Profilim"
                                }
                            ];
                            
                        case Enums.MENU_TYPE.RESOURCE:
                            return [
                                { icon: "icon-book", link: Links.Resource.List, args: [2], text: "Soru Bankası" },
                                { icon: "icon-books-list", link: Links.Resource.List, args: [1], text: "Konu Anlatım" },
                                { icon: "icon-chemistry-lesson", link: Links.Resource.List, args: [3], text: "Deneme" },
                                null,
                                { icon: "icon-chevron-left", link: Links.Dashboard, text: "Panelim", isMain: true },
                            ];

                        case Enums.MENU_TYPE.DOCUMENT:
                            return [
                                { icon: "icon-bookmark", link: Links.Document.PrivateList, args: [0], text: "Özel" },
                                { icon: "icon-folderbag", link: Links.Document.PublicList, text: "Genel" },
                                { icon: "icon-exam", link: Links.Document.TestList, text: "Testler" },
                                { icon: "icon-file-circle-question", link: Links.Document.QuestionList, text: "Soru Havuzu" },
                                { icon: "icon-chevron-left", link: Links.Dashboard, text: "Panelim", isMain: true },
                            ];

                        case Enums.MENU_TYPE.MAIN:
                        default:
                            return [
                                { icon: "icon-books-list", link: Links.Document.PrivateList, args: [0], text: "Dokümanlarım" },
                                { icon: "icon-calendar-days-regular", link: Links.Plan.WeeklyList, text: "Koçluk", isMain: true },
                                { icon: "icon-user", link: Links.User.Profile, text: "Hesabım" },
                            ];
                    }
                }),
            });

            return { ...toRefs(e) };
        },
    };
</script>